<template>
  <v-card
    class="fill-height property-item"
    :id="uuid"
    @mouseover="$emit('mouseover', uuid, quadkey)"
    @mouseout="$emit('mouseout', uuid, quadkey)"
  >
    <v-layout justify-start column fill-height>
      <v-flex shrink class="-pt-0 advert-slider">
        <photos :uuid="uuid" :images="images_arr" />
        <!-- <v-img class="-slide-16-9" aspect-ratio="1.778" @load="onLoadImage" :src="thumb_url">
          <v-card-title class="align-start">
            <v-layout align-center justify-start row spacer>
              <v-flex shrink>
                <v-chip
                  label
                  v-if="is_new && !is_featured"
                  color="secondary"
                  class="mx-2 mb-2"
                >{{ trans('advert.is_new') }}</v-chip>

                <v-chip
                  label
                  v-if="is_featured"
                  color="primary"
                  class="mx-2 mb-2"
                >{{ trans('advert.is_featured') }}</v-chip>
              </v-flex>

              <v-flex></v-flex>
              <v-flex shrink v-if="authenticated && can_favorite">
                <v-btn
                  v-if="is_favorited"
                  fab
                  light
                  small
                  depressed
                  color="primary"
                  class="elevation-1 mr-3"
                  @click.stop="toggleFavorite"
                >
                  <v-icon small dark color="white">mdi-star</v-icon>
                </v-btn>
                <v-btn
                  v-if="!is_favorited"
                  fab
                  dark
                  small
                  depressed
                  color="white"
                  class="elevation-1 mr-3"
                  @click.stop="toggleFavorite"
                >
                  <v-icon small dark color="secondary">mdi-star</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-img>-->
        <div class="white--text advert-price">
          <span class="title">{{ price_total }}</span>
          <span>{{ price_unit }}</span>
        </div>
        <div class="advert-shadow"></div>
        <div style="position:absolute;top:10px;right:10px;z-index:1;">
          <v-btn dark x-small fab color="blue-grey lighten-5" @click="toggleFavorite">
            <v-icon dark :color="is_favorited ? 'pink' : 'blue-grey'">mdi-heart</v-icon>
          </v-btn>
        </div>
      </v-flex>

      <v-flex grow>
        <v-card-text>
          <v-list-item two-line class="px-0">
            <v-list-item-content class="py-0">
              <v-list-item-title @click.stop="$emit('click', uuid)">
                <span class="advert-title">{{ title }}</span>
              </v-list-item-title>

              <v-list-item-subtitle>
                <span class="body-2">{{ trans('advert.property_type_' + property_type) }}</span>
                <span>{{' · '}}</span>
                <span class="body-2">{{ occupants }} person(s)</span>
                <span>{{' · '}}</span>
                <span class="body-2">Rent Term: {{ rent_term }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item-content class="py-1">
            <v-list-item-subtitle>{{ address }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-card-text>
      </v-flex>

      <!-- <v-flex shrink>
        <v-divider></v-divider>

        <advert-author-short :user="author"></advert-author-short>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <slot></slot>
        </v-card-actions>
      </v-flex>-->
    </v-layout>
  </v-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import AdvertAuthorShort from "./AdvertAuthorShort";
import Photos from "./advert-item/Photos";

export default {
  components: {
    AdvertAuthorShort,
    photos: Photos
  },
  computed: {
    ...mapState("auth", {
      authenticated: "authenticated"
    }),

    address: function() {
      return _.get(
        this.$props,
        "formatted_address",
        this.trans("advert.address_unknown")
      );
    },

    thumb_url: function() {
      let url = _.get(this.$props, "images[0].urls.lg", null);
      if (!url) return this.faker.thumb;
      return this.url("media/" + url);
    },
    images_arr() {
      return this.$props.images;
    },

    price_unit: function() {
      let currency = this.trans(`advert.price_currency_${this.price_currency}`);
      let unit = this.trans(
        `advert.rent_period_${_.get(this.$props, "rent_period", "month")}`
      );
      return `${currency}/${unit}`;
    },

    is_new: function() {
      var now = moment();
      var then = moment(this.$props.created_at);
      return now.diff(then, "days") <= 3;
    },

    is_featured: function() {
      return this.$props.featured;
    }
  },

  methods: {
    ...mapActions("search", {
      addToFavorites: "addToFavorites",
      removeFromFavorites: "removeFromFavorites"
    }),

    onLoadImage: function() {
      this.$forceUpdate();
    },

    toggleFavorite: function() {
      let uuid = this.$props.uuid;
      if (this.$props.is_favorited == true) {
        this.removeFromFavorites(uuid);
      } else {
        this.addToFavorites(uuid);
      }
    }
  },

  mounted: function() {
    // this.$store.subscribe(({type, payload}, state) => {
    // 	// ...
    // })
  },

  props: [
    "can_favorite",

    "uuid",
    "property_type",
    "room_amount",
    "occupants_max",
    "occupants_amount",
    "occupants",
    "owner_type",
    "price_value",
    "price_total",
    "price_currency",
    "rent_period",
    "security_deposit",
    "area",
    "area_unit",
    "transport_mode",
    "transport_duration",
    "transport_from",
    "transport_line",
    "living_room",
    "amenities",
    "facilities",
    "room_size",
    "available_from",
    "bills_included",
    "est_bill_amount",
    "broadband_included",
    "tenant_smoking",
    "tenant_occupation",
    "tenant_pets",
    "tenant_gender",
    "tenant_age_min",
    "tenant_age_max",
    "tenant_language",
    "tenant_couples",
    "flatmate_smoking",
    "flatmate_gender",
    "flatmate_occupation",
    "flatmate_pets",
    "flatmate_age",
    "flatmate_language",
    "flatmate_nationality",
    "flatmate_interests",
    "title",
    "description",
    "has_media",
    "featured",
    "status",
    "created_by",
    "created_at",
    "updated_at",
    "deleted_at",
    "author",
    "rent_term",
    // 'role',
    // 'locale',
    // 'email',
    // 'phone_number',
    // 'first_name',
    // 'last_name',
    // 'email_visible',
    // 'phone_number_visible',
    // 'last_name_visible',
    // 'email_verified',
    // 'phone_number_verified',
    // 'provider',
    // 'locked_at',
    // 'deleted_at',
    // 'filled',
    // 'activity',
    "location",
    // 'uuid',
    // 'property_uuid',
    "place_id",
    "lat",
    "lng",
    "quadkey",
    "deckey",
    "postal_code",
    "country",
    "locality",
    "sublocality",
    "route",
    "street_number",
    "country_uuid",
    "locality_uuid",
    "sublocality_uuid",
    "route_uuid",
    "count",
    "longitude",
    "latitude",
    "is_cluster",
    "prefix",

    "formatted_address",
    "images",
    "is_favorited"
  ]
};
</script>
